import React, { useState, useContext } from 'react';
import { AppContext } from '../../context/index';
import { withRouter } from 'react-router-dom';
import { Nav, NavItem, TabContent, TabPane, Row, Col } from 'reactstrap';
import { NavLink } from 'react-router-dom';
import classnames from 'classnames';

import AppLayout from '../../components/AppLayout';
import Profile from '../../components/portal/Profile';
import { notify } from '../../utils';
import Layout from '../../components/custom/Layout';

const Portal = () => {
    const {
        user,
        readingSigns,
        setReadingSigns,
        trainingAssigned
    } = useContext(AppContext);

    const [activeFirstTab, setActiveFirstTab] = useState('1');

    const toggleTab = (tab) => {
        if (activeFirstTab !== tab) {
            setActiveFirstTab(tab);
        }
    };

    return (
        <Layout>

            <div className="card-body mb-5 px-1 py-1">
                <Row className="px-3 py-3" data-testid={'view-portal'}>
                    <Col md="12" lg="12">
                        <Row>
                            <h1
                                className="pl-3"
                                style={{ position: 'relative', top: '6px' }}
                                data-testid={'text-display-name'}
                                onClick={() => notify('test')}
                            >
                                Welcome {user && user.displayName}
                            </h1>
                        </Row>
                        <Row className="mt-2">
                            <Col mg="12" lg="12">
                                <Nav
                                    tabs
                                    className="separator-tabs ml-0 mb-2"
                                >
                                    <NavItem>
                                        <NavLink
                                            location={{}}
                                            to="#"
                                            className={classnames({
                                                active:
                                                    activeFirstTab === '1',
                                                'nav-link': true,
                                            })}
                                            onClick={() => {
                                                toggleTab('1');
                                            }}
                                        >
                                            Profile
                                        </NavLink>
                                    </NavItem>
                                </Nav>
                            </Col>
                        </Row>

                        <TabContent
                            activeTab={activeFirstTab}
                            className="mt-2"
                        >
                            <TabPane tabId="1">
                                <Profile
                                    user={user}
                                    readingSigns={readingSigns}
                                    setReadingSigns={setReadingSigns}
                                    trainingAssigned={trainingAssigned}
                                />
                            </TabPane>
                        </TabContent>
                    </Col>
                </Row>
            </div>
        </Layout>
    );
};

export default withRouter(Portal);
